
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Badge } from '@/components/ui/badge';

interface VersionChangeConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  currentVersion: number;
}

export function VersionChangeConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  currentVersion
}: VersionChangeConfirmDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Create New Assessment Version?</AlertDialogTitle>
          <AlertDialogDescription>
            You're about to make changes to the questions or categories of this published assessment.
            This will create version <Badge variant="outline" className="ml-1">{currentVersion + 1}</Badge> 
            of the assessment.
            <div className="mt-4 bg-amber-50 border border-amber-200 p-3 rounded-md text-amber-800">
              <strong>Note:</strong> Existing responses will still be tied to their original version.
              New users will see this new version.
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Create Version {currentVersion + 1}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
